import { StyleSheet } from "react-native";
import { AppTheme } from "../../theme";

export const productSettingsStyle = (theme: AppTheme) => StyleSheet.create({
    outerContainer: {
        flex: 1,
        backgroundColor: theme?.lightBackgroundColor,
    },
    scrollContent: {
        paddingBottom: 20,
    },
    sectionsWrapper: {
        gap: 16,
        marginHorizontal: 12,
        marginTop: 12,
        marginBottom: 20,
    },
    card: {
        backgroundColor: theme?.light,
        borderRadius: 12,
        padding: 16,
        elevation: 2,
        shadowColor: theme?.dark,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
    },
    cardTitle: {
        marginBottom: 4,
    },
    cardSubTitle: {
        marginBottom: 16,
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingVertical: 12,
        paddingHorizontal: 12,
        backgroundColor: theme?.lightBackgroundColor,
        borderRadius: 8,
        // Keeps the whole row within the 44pt touch target guidance.
        minHeight: 48,
    },
    rowLabelWrapper: {
        flex: 1,
        marginRight: 10,
    },
    rowGroup: {
        gap: 12,
    },
    fieldWrapper: {
        marginTop: 16,
    },
    fieldLabel: {
        marginBottom: 5,
        fontFamily: theme?.medium,
        fontSize: theme?.smallerFontSize,
        color: theme?.labelColor,
    },
    inputContainer: {
        paddingHorizontal: 0,
    },
    inputInnerContainer: {
        paddingHorizontal: 8,
    },
    errorStyle: {
        fontSize: theme?.errorFontSize,
        fontFamily: theme?.medium,
        color: theme?.red,
    },
    separatorRow: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        columnGap: 10,
    },
    helperText: {
        marginTop: 2,
    },
    customLayoutCard: {
        marginTop: 16,
        padding: 12,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: theme?.borderColor,
        backgroundColor: theme?.lightBackgroundColor,
        gap: 16,
    },
    customGroup: {
        gap: 8,
    },
    customGrid: {
        flexDirection: "row",
        flexWrap: "wrap",
        columnGap: 12,
        rowGap: 12,
    },
    // Two per row on a phone, more on a tablet once the card is wider.
    customField: {
        flexGrow: 1,
        flexBasis: 130,
        minWidth: 130,
    },
    previewCard: {
        marginTop: 16,
        padding: 12,
        borderRadius: 8,
        borderWidth: 1,
        borderStyle: "dashed",
        borderColor: theme?.primary,
        backgroundColor: theme?.tealPrimary,
    },
    previewValue: {
        marginTop: 6,
        letterSpacing: 1,
    },
    counterRow: {
        marginTop: 16,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
    },
    infoNote: {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 8,
        padding: 10,
        borderRadius: 8,
        backgroundColor: theme?.lightPrimary,
        marginBottom: 16,
    },
    reorderActions: {
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
    },
    reorderButton: {
        padding: 6,
        borderRadius: 6,
    },
    orderBadge: {
        width: 22,
        height: 22,
        borderRadius: 11,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme?.primary,
        marginRight: 8,
    },
    labelPreviewRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingVertical: 3,
        gap: 10,
    },
    barcodePlaceholder: {
        marginTop: 10,
        paddingTop: 10,
        borderTopWidth: 1,
        borderTopColor: theme?.borderColor,
        alignItems: "center",
    },
    footer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        columnGap: 10,
    },
    footerButtonContainer: {
        borderRadius: 10,
    },
    outlineButton: {
        backgroundColor: theme?.light,
        borderRadius: 10,
    },
    primaryButton: {
        backgroundColor: theme?.primary,
        borderRadius: 10,
    },
    disabledButton: {
        backgroundColor: theme?.lightGrey,
        borderRadius: 10,
    },
    skeletonCard: {
        gap: 12,
    },
    errorBanner: {
        marginHorizontal: 12,
        marginTop: 12,
        padding: 12,
        borderRadius: 8,
        backgroundColor: theme?.whiteRed,
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
    },
});
